import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { AppNamePicker, appNamePickerValidation } from './AppNamePicker';

/** `ui:field: AppNamePicker`: app-bootstrap app name, checked for uniqueness across BUs. */
export const AppNamePickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AppNamePicker',
    component: AppNamePicker,
    validation: appNamePickerValidation,
  }),
);
